import script from "./PayrollLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollLayout.vue?vue&type=script&setup=true&lang=js"

import "./PayrollLayout.vue?vue&type=style&index=0&id=3084c438&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3084c438"]])

export default __exports__